import { SEO } from "./seo"

export class Sponsor {
    id?: any;
    title?: any;
    subtitle?: any;
    position?: any;
    code?: any;
    image?: any;
    externalLink?: any;
    description?: any;
    idSeoFk?: any;

    seo?: SEO;
    sponsorImages?: {
        id: any;
        url?: any;
        name?: any;
        order?: any;
    }[]



    // Solo para el formulario
    imgAction?: {
        imageAddList: any[]
        imageUpdateList: any[]
        deleteImageList: any[]
    }
}